const actionSetLoader = ({commit, state}) => {
  commit('SET_LOADER', state.loader ? !state.loader : true);
}
export default {
  actionSetLoader
}